import { isLocal, setSessionItem } from '@/utils/utils';
import Type from '@/store/mutation-type';
import { login } from '@/api/auth';
import CryptoJS from 'crypto-js';
import ctt from '@/utils/const';
import { isDetectDevice, isMonitorDevice } from '@/utils/deviceUtils/index';
import { isAlarmOrWarn, isOffline, normalizeState } from '@/utils/deviceUtils/state';
// import { getTime } from '@/utils/date';
// import { isNullOrUnDef } from '@/utils/is';
import { getLang, langs, setLang } from '@/locale';

export default {
  namespaced: true,
  state: {
    fullScreenFlag: true,
    theme: 'dark',
    themeList: ['dark', 'light', 'normal'],
    validAlarmNotice: true, // 是否启用报警提示
    menuCollapse: true, // 菜单是否隐藏
    deviceModel: 'scene', // 设备监控中间展示地图还是设备
    stateModel: 'all', // 状态报告模式
    deviceMenuCollapse: false, // 任务管理是否隐藏
    alarmVoice: true, // 报警声音是否开启
    isLocal: isLocal(), // 是否为本地版本
    mulDevicesSelected: [], // 多设备界面被选择设备sn
    network: true, // 网络连接情况
    silentList: [], // 设备报警静音列表
    alarmIdList: [], // 静音列表 报警设备sn+beginTime,[sn-beginTime,]
    cacheComponents: ['historyWarn', 'checkList', 'trackReplay'], // keepalive 组件
    lang: getLang(),
    langs: langs,
    alarmTimers: {} // 存储设备报警定时器
  },
  getters: {
    title(state) {
      //   return i18n.t('title');
      return state.title;
    }
  },
  mutations: {
    setFullScreenFlag(state, flag) {
      state.fullScreenFlag = flag;
    },
    setTheme(state, theme) {
      state.theme = theme;
    },
    [Type.CHANGE_COLLAPSE](state) {
      state.menuCollapse = !state.menuCollapse;
    },
    [Type.DEVICE_MODEL](state, model) {
      state.deviceModel = model;
    },
    [Type.STATE_MODEL](state, model) {
      state.stateModel = model;
    },
    [Type.DEVICE_MENU_COLLAPSE](state) {
      state.deviceMenuCollapse = !state.deviceMenuCollapse;
    },
    [Type.ALARM_VOICE](state, voice) {
      if (voice) {
        state.alarmVoice = voice;
      } else {
        state.alarmVoice = !state.alarmVoice;
      }
    },
    [Type.SAVE_MUL_DEVICES](state, { deivces, selected }) {
      if (selected) {
        // selected长度一定为3
        state.mulDevicesSelected = deivces
          .filter(e => {
            return selected.indexOf(e.sn) > -1;
          })
          .map(item => {
            return item.sn;
          });
      } else {
        if (state.mulDevicesSelected.length === 0) {
          let val = deivces
            .filter(e => (e.state === 0 || e.state) && e.state !== -1)
            .slice(0, 3)
            .map(e => e.sn);
          state.mulDevicesSelected = val && val.length ? val : deivces.slice(0, 3).map(e => e.sn);
        }
      }
    },
    [Type.NETWORK](state, flag) {
      state.network = flag;
    },
    [Type.ADD_CACHE](state, name) {
      state.cacheComponents.push(name);
    },
    [Type.DEL_CACHE](state, name) {
      const i = state.cacheComponents.findIndex(e => e === name);
      state.cacheComponents.splice(i, 1);
    },
    [Type.SET_TITLE](state, title) {
      state.title = title;
    },
    [Type.ENABLE_ALARM_NOTICE](state, val) {
      state.validAlarmNotice = val;
    },
    [Type.SET_ALARM_TIMER](state, { sn, timerId }) {
      state.alarmTimers[sn] = timerId;
    },
    [Type.CLEAR_ALARM_TIMER](state, sn) {
      if (state.alarmTimers[sn]) {
        clearTimeout(state.alarmTimers[sn]);
        delete state.alarmTimers[sn];
      }
    }
  },
  actions: {
    setLang({ state }, lang) {
      const l = setLang(lang);

      state.lang = l;
    },
    // [Type.MQTT_BASIC_DATA]({ state, commit }, data) {
    //   if (!state.silentList.includes(data.sn)) return;

    //   if (!isAlarmOrWarn(data.state) || isOffline({ data })) {
    //     const timerId = setTimeout(() => {
    //       state.silentList.splice(state.silentList.indexOf(data.sn), 1);
    //       commit(clearAlarmTime, data.sn);
    //     }, 1200);
    //   }
    // },

    [Type.MQTT_BASIC_DATA]({ state, commit }, data) {
      if (!state.silentList.includes(data.sn)) return;

      // 清除可能存在的旧定时器
      commit(Type.CLEAR_ALARM_TIMER, data.sn);

      if (!isAlarmOrWarn(data.state) || isOffline({ data })) {
        const timerId = setTimeout(() => {
          state.silentList.splice(state.silentList.indexOf(data.sn), 1);
          commit(Type.CLEAR_ALARM_TIMER, data.sn);
        }, 1200);

        // 保存新的定时器
        commit(Type.SET_ALARM_TIMER, { sn: data.sn, timerId });
      }
    },
    async login(_, params) {
      let { username, password } = params;
      let key = username.padEnd(9, 0);
      key = CryptoJS.enc.Utf8.parse(key);
      password = CryptoJS.DES.encrypt(password, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString();

      const res = await login(username, password);

      setSessionItem(ctt.ADMIN_TOKEN, res.data);
      return res;
    },
    silentAlarmDevice({ state, rootGetters }) {
      const list = rootGetters['socket/alarmDeviceList'];

      //   const snList = list.map(e => e.sn);
      list.forEach(e => {
        if (isMonitorDevice(e.runMode)) {
          state.silentList.push(e.sn);
        } else if (isDetectDevice(e.runMode)) {
          normalizeState(e);
        }
      });

      //   if (!isNullOrUnDef(snList)) {
      //     timer(() => {
      //       let index = null;
      //       snList.forEach(sn => {
      //         index = state.silentList.findIndex(e => e === sn);
      //         if (index !== -1) state.silentList.splice(index, 1);
      //       });
      //     }, getTime('m') * 5);
      //   }
    }
  }
};
